import debug from 'jsbug'

export default function createStoreLogger(storeList) {

  let functionCount = {};

  const style = 'color:#111;background:#eee;font-weight:bold';
  console.log("%c Type \"window.VuexStore.commit('logger/PRINT_STATS')\" to see stats.", style);
  console.log("%c To enable debug output append '?jsbug=true' to URL (=false to disable).", style);

  return store => {

    store.subscribe((mutation, state) => {
      if (mutation.type === 'logger/PRINT_STATS') {
        Object.keys(functionCount).forEach(key => {
          debug( key + ': #' + functionCount[key]);
        })
        console.table(functionCount);
      }
    });

    store.subscribeAction(({ type, payload }, state) => {
      if ( storeList.some(item => type.startsWith(item)) ) {
        let group;
        if (payload !== null && typeof payload === 'object') {
          group = Object.keys(payload).map(key => ({ [key]: payload[key] }));
        } else {
          group = { 'payload': payload };
        }
        debug(type, {
          color: '#6A36CB',
          group: group
        });
      }

      // let typeSegments = type.split('/');
      // let storeName = typeSegments[0];
      // let actionName = typeSegments[1];

      if ( type in functionCount ) {
        functionCount[type] += 1;
      } else {
        functionCount[type] = 1;
      }
    })
  };
};

export const loggerMutations = {
  'logger/PRINT_STATS' (state) {
    /* Do nothing here */
  }
}

/*
See also: https://vuex.vuejs.org/guide/plugins.html#built-in-logger-plugin
*/
